const ConfirmedReseller = ({ ..._props }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_12475_41677)">
        <path d="M8 0L0 6.33455L8 8.79273V0Z" fill="#B366FF" />
        <path d="M16 6.33455L8 0V8.79273L16 6.33455Z" fill="#9933FF" />
        <path
          d="M12.9455 15.215L16 6.33496L8 8.79314L12.9455 15.215Z"
          fill="#7A29CC"
        />
        <path d="M8 8.79297V15.2148H12.9455L8 8.79297Z" fill="#9933FF" />
        <path
          d="M0 6.33496L3.05455 15.215L8 8.79314L0 6.33496Z"
          fill="#9933FF"
        />
        <path
          d="M3.05457 15.2148H8.00002V8.79297L3.05457 15.2148Z"
          fill="#B366FF"
        />
        <path
          d="M4.13818 7.60772L5.61455 11.8914H8V4.5459L4.13818 7.60772Z"
          fill="#CC99FF"
        />
        <path
          d="M11.8618 7.60772L8 4.5459V11.8914H10.3855L11.8618 7.60772Z"
          fill="#B366FF"
        />
      </g>
      <defs>
        <clipPath id="clip0_12475_41677">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ConfirmedReseller;
